<template>
  <div>
    <div class="page-title top0">操作日志</div>
    <!-- 表单查询 -->
    <el-form ref="queryFormRef" class="query-form" label-width="80px" :model="queryForm" inline>
      <!-- <div> -->
      <el-form-item label="公司主体">
        <el-select style="width: 180px" v-model="queryForm.enterpriseId" @change="operatorList(), changeTime()" filterable clearable placeholder="请选择">
          <el-option
            v-for="item in companyData"
            :key="item.id"
            :label="item.enterpriseName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作人">
        <el-select style="width: 150px" v-model="queryForm.employeeId" @change="changeTime" filterable clearable placeholder="请选择">
          <el-option
            v-for="item in operatorLists"
            :key="item.id"
            :label="item.employeeName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker @change="changeTime"
          v-model="timeDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <!-- </div> -->
      <!-- <div> -->
      <el-form-item label="操作对象">
        <el-select style="width: 180px" v-model="queryForm.operateTarget" @change="changeTime" clearable placeholder="请选择">
          <el-option :value="1" label="投放账户"></el-option>
          <el-option :value="2" label="广告组"></el-option>
          <el-option :value="3" label="计划"></el-option>
          <el-option :value="4" label="创意"></el-option>
          <el-option :value="5" label="策略"></el-option>
          <el-option :value="6" label="模板"></el-option>
          <el-option :value="7" label="智运营"></el-option>
          <el-option :value="8" label="基础报表"></el-option>
          <el-option :value="9" label="飞鱼线索"></el-option>
          <el-option :value="10" label="监控"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作动作">
        <el-select style="width: 150px" v-model="queryForm.operateType" @change="changeTime" clearable placeholder="请选择">
          <el-option :value="1" label="授权"></el-option>
          <el-option :value="2" label="新建"></el-option>
          <el-option :value="3" label="修改"></el-option>
          <el-option :value="4" label="修改状态"></el-option>
          <el-option :value="5" label="删除"></el-option>
          <el-option :value="6" label="复制"></el-option>
          <el-option :value="7" label="导出"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账户名称（ID）" label-width="120px">
        <el-input placeholder="请输入" v-model="queryForm.accountNameId" class="input-with-search" style="width: 250px">
          <el-button @click="changeTime" slot="append" icon="iconfont icon-sousuo"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="计划名称" label-width="80px">
        <el-input placeholder="请输入" v-model="queryForm.adPlanNameId" class="input-with-search" style="width: 200px">
          <el-button @click="changeTime" slot="append" icon="iconfont icon-sousuo"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="resetForm" size="medium" type="info">重置选项</el-button>
        <el-button :disabled="tableData.length === 0" @click="downloadReport" size="medium" type="primary">导出日志</el-button>
      </el-form-item>
      <!-- </div> -->
    </el-form>
    <!-- 表格 -->
    <el-table
      class="roleTable"
      :data="tableData" v-loading="tableLoading"
      border style="width: 100%">
      <el-table-column
       width="150"
        prop="createTime"
        label="操作时间">
      </el-table-column>
      <el-table-column
        width="80"
        prop="employeeName"
        label="操作人">
      </el-table-column>
      <el-table-column
        width="120"
        prop="enterpriseName"
        label="公司名称">
      </el-table-column>
      <el-table-column
        width="150"
        prop="accountName"
        label="操作账户">
      </el-table-column>
      <el-table-column
        width="150"
        prop="operateTargetVo"
        label="操作对象">
        <template slot-scope="scope">
          {{scope.row.operateTargetVo}}
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        prop="operateType"
        label="操作动作">
      </el-table-column>
      <el-table-column
        prop="operateResult"
        label="操作结果">
        <template slot-scope="scope">
          <div class="reslut-div" v-html="scope.row.operateResult"></div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="operateIp"
        label="操作IP">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paging-box" v-if="pageTotal > 0">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="queryForm.pageNum"
        :page-size="queryForm.pageSize"
        layout="total, prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 公用
import { getTimeAll, getTime } from '@/components/public'
export default {
  name: 'operationLog',
  data () {
    return {
      tableLoading: false,
      timeDate: [getTime(new Date()), getTime(new Date())],
      // 查询表单
      queryForm: {
        startTime: getTime(new Date()),
        endTime: getTime(new Date()),
        enterpriseId: '', // 企业id
        employeeId: '', // 操作人员ID
        operateTarget: '', // 操作对象
        operateType: '', // 操作动作
        accountNameId: '', // 账户名称（ID）
        adPlanNameId: '', // 计划名称（ID）
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      // 选择公司名称
      companyData: [],
      // 选择操作人
      operatorLists: [],
      // 表格数据
      tableData: []
    }
  },
  created () {
    this.operateLogListData() // 表格数据
    this.getCompanyList() // 获取公司名称下拉框
  },
  watch: {
  },
  computed: {
  },
  methods: {
    // 下载报表
    downloadReport () {
      if (this.timeDate) {
        this.queryForm.startTime = this.timeDate[0]
        this.queryForm.endTime = this.timeDate[1]
      } else {
        this.queryForm.startTime = ''
        this.queryForm.endTime = ''
      }
      // 创建a标签下载
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.$instance.defaults.baseURL + '/api/operateLog/download?enterpriseId=' +
      this.queryForm.enterpriseId + '&employeeId=' + this.queryForm.employeeId +
      '&operateTarget=' + this.queryForm.operateTarget + '&operateType=' + this.queryForm.operateType +
      '&accountNameId=' + this.queryForm.accountNameId + '&adPlanNameId=' + this.queryForm.adPlanNameId +
      '&endTime=' + this.queryForm.endTime + '&startTime=' + this.queryForm.startTime
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    // 切换分页
    handleCurrentChange (val) {
      this.operateLogListData()
    },
    // 获取查询数据
    operateLogListData () {
      if (this.timeDate) {
        this.queryForm.startTime = this.timeDate[0]
        this.queryForm.endTime = this.timeDate[1]
      } else {
        this.queryForm.startTime = ''
        this.queryForm.endTime = ''
      }
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/operateLog/getList', this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.tableData = res.result.pageData
          this.pageTotal = res.result.total
          this.tableData.forEach((item, index) => {
            item.createTime = getTimeAll(new Date(item.createTime))
          })
        }
      }).catch(Err => {})
    },
    // 选择时间获取表格数据
    changeTime () {
      this.queryForm.pageNum = 1
      this.operateLogListData()
    },
    // 公司名称下拉框
    getCompanyList () {
      this.$service.post('/api/enterprise/getAllCompanyList').then(res => {
        if (res.code === 200) {
          this.companyData = res.result
        }
      }).catch(Err => {})
    },
    // 操作人
    operatorList () {
      this.queryForm.employeeId = ''
      if (this.queryForm.enterpriseId === '') {
        this.operatorLists = []
      } else {
        this.$service.post('/api/employee/getAllUserByEnterprise', {enterpriseId: this.queryForm.enterpriseId}).then(res => {
          if (res.code === 200) {
            this.operatorLists = res.result
          }
        }).catch(Err => {})
      }
    },
    // 重置选项
    resetForm () {
      this.queryForm = {
        startTime: getTime(new Date()),
        endTime: getTime(new Date()),
        enterpriseId: '', // 企业id
        employeeId: '', // 操作人员ID
        operateTarget: '', // 操作对象
        operateType: '', // 操作动作
        accountNameId: '', // 账户名称（ID）
        adPlanNameId: '', // 计划名称（ID）
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      }
      this.companyData = []
      this.operatorLists = []
      this.timeDate = [getTime(new Date()), getTime(new Date())]
      this.getCompanyList() //  公司名称下拉框
      this.operateLogListData()
    }
  }
}
</script>

<style lang="less" scoped>
.query-form{
  margin-bottom: -21px;
}
.reslut-div{
  max-height: 150px;
  overflow-y: auto;
  text-align: left;
  &::-webkit-scrollbar {
    width: 5px;
    height: 1px;
  }
  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/operationManage/operationLog.vue